<!--<div *ngIf="isId3confirrmation">
  test
</div>-->
<div class="details-cmd">
  <div class="container">
    <header class="flexible">
      <h5 class="inline-block text-uppercase">01. {{'front_booking_payment.summary'| translate}}</h5>
      <a [routerLink]="['/event/booking/infos']" title="Montrer/Cacher les détails" class="inline-block text-uppercase">
        <i class="fa fa-edit"></i>
      </a>
    </header>

    <div class="table-wrapper">
      <div class="width-100 table">
        <div class="flexible table-row width-100">
          <div class="flexible width-100" style="background-color: #F4F2F3">
            <div class="column-header flexible title text-left col-md-8">
              <span> </span>
              <span class="opacity-50"></span>
            </div>
            <div class="column-header ft-size-13 recap-items flexible"><span class="price" >{{'front_booking_payment.unit_price'| translate}} </span></div>
            <div class="column-header ft-size-13 recap-items flexible">{{'front_booking_payment.quantity'| translate}}</div>
            <div class="column-header ft-size-13 recap-items flexible"><span class="price" >{{'front_booking_payment.total_price'| translate}}</span></div>
          </div>
        </div>
        <div *ngFor="let pricing of pricings let idxP=index">
        <div>
          <div class="table-row flexible width-100">
            <!--<div  *ngIf="pricing.nbreTicket>0" class="column flexible index text-center">{{idx}}</div>-->
            <div  *ngIf="pricing.nbreTicket > 0" class="flexible width-100 border-bottom-1">
              <div class="column flexible recap-items col-md-8">
                <span class="padding-10" style="word-break: break-all;">{{pricing.label}}</span>
                <span class="opacity-50"><!--({{dayname}},  {{ day}} {{month}} à {{hours}}H)--><!--(Sun, 22 Jun 2014 at 08:45 AM)--></span>
              </div>
              <div class="column flexible recap-items" *ngIf="functionUtils.getPricingPrice(pricing) > 0">
              <span class="price margin-auto">
                <span>
                  {{functionUtils.getPricingPrice(pricing)}}{{functionUtils.getPricingDeviseSymbole(pricing.devise)}}
                </span>
                <span *ngIf="pricing.codePromo">{{' => '}}</span>
                <span *ngIf="pricing.codePromo">
                  {{functionUtils.calculatePricingPriceAfterPromoApply(pricing)}}{{functionUtils.getPricingDeviseSymbole(pricing.devise)}}
                </span>
              </span>
              </div>
              <div class="column flexible recap-items" *ngIf="functionUtils.getPricingPrice(pricing) == 0"><span class="price margin-auto">Gratuit</span></div>
              <div class="column flexible flexible recap-items"><span class="price margin-auto">{{pricing.nbreTicket}}</span></div>
              <div class="column flexible recap-items" *ngIf="!pricing.open && functionUtils.getPricingPrice(pricing) > 0"><span class="price margin-auto">{{showPrice(pricing.nbreTicket * functionUtils.getPricingPrice(pricing) - functionUtils.pricingReduction(pricing)) + ' ' + showCurrency(functionUtils.getPricingDeviseSymbole(pricing.devise),pricing.nbreTicket * functionUtils.getPricingPrice(pricing) - functionUtils.pricingReduction(pricing))}}</span></div>
              <div class="column flexible recap-items" *ngIf="!pricing.open && functionUtils.getPricingPrice(pricing) == 0"><span class="price margin-auto ">Gratuit</span></div>
              <div class="column flexible recap-items" *ngIf="pricing.open"><span class="price margin-auto ">{{functionUtils.getPricingPrice(pricing)+' '+functionUtils.getPricingDeviseSymbole(pricing.devise)}}</span></div>
            </div>
          </div>
        </div>
          <div class="flexible width-100" *ngIf="pricing.nbreTicket > 0" style="background-color: #F4F2F3">
            <ul  class="holders-list-1" *ngIf="getPricingBookingTicket(pricing.id).length >0">
              <li class="ft-size-14 padding-t-b-5"  *ngFor="let ticket of getPricingBookingTicket(pricing.id) let idx = index">
                Participant  <span>{{' '+ ticket.id}}</span>:
                <span class="padding-10">{{ticket.firstname}} {{ ticket.lastname}}</span> <br>
                <span *ngIf="ticket.options">
                   <ng-container *ngFor="let option of ticket.options">
                     <span>{{option.name}}</span>{{' : '+option.price+' €'}} <br>
                   </ng-container>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="flexible width-100 toto m-top-10">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_payment.subtotal'| translate}}</div>
              <span class="price-2 width-10px">{{ displayTotal(calculTotal(pricings)) }}</span>
            </div>
          </div>
        </div>
        <div class="flexible width-100 toto">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_payment.booking_fee'| translate}}</div>
              <span class="price-2 width-10px">{{displayTotal(frais)}}</span>
            </div>
          </div>
        </div>
        <div class="flexible width-100 toto">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_payment.total'| translate}}</div>
              <span class="price-2 width-10px text-green">{{ displayTotal(order.total_price) }}</span>
            </div>
          </div>
        </div>

        <!--<div style="margin-top: 50px">
          <div *ngFor="let booking of bookingLists">
            &lt;!&ndash;<span  *ngIf="booking.tickets.length>0">{{ booking.Pricing_label}}</span>&ndash;&gt;
            <ul  class="holders-list" *ngIf="booking.tickets.length >0">
              <li  *ngFor="let ticket of booking.tickets let idx = index">
                {{'front_booking_payment.carrier_N_'| translate}} {{ idx+1 }}:
                <span>{{ticket.firstname}} <b>{{ ticket.lastname}}</b></span> <br>
                <span *ngIf="ticket.options">
                   <ng-container *ngFor="let option of ticket.options">
                     <span>{{option.name}}</span>{{' : '+option.price+' €'}} <br>
                   </ng-container>
                </span>
              </li>
            </ul>
          </div>
        </div>-->

        <!--<header class="flexible">
          <h5 class="inline-block text-uppercase">05. Moyen de paiement</h5>
          <a [routerLink]="['/event/booking/infos']"  class="inline-block text-uppercase"></a>
        </header>
        <div>

        </div>

        <div class="form-group row col-md-10 font-size-18 margin-bottom-20" style="margin-top: 20px" *ngIf="calculTotal(pricings)> event.paymentStartFrom && eventGotMultiPayment() ">

              <div class="col-md-5 checkbox">
                <label><input type="checkbox" class="customYumanCheckBox" [checked]="isNormalPayment"  (change)="normalPayment($event)" value="">
                  <img style="margin-left: 10px" src="../../../../assets/imgs/credit-card.png" width="48" height="40" alt="credit-card">
                  <span class="customYumanCheckboxLabel" style="margin-left: 10px">Carte bancaire</span>
                </label>
              </div>

              <div class="col-md-5 checkbox">
                <span *ngIf="event.number_of_maturity == 4"> <img style="margin-left: 10px;width: 98px;height: 33px;margin-bottom:9px" src="../../../../assets/imgs/4X.png" width="48" height="40" alt="credit-card"></span>
                <span *ngIf="event.number_of_maturity == 3"> <img style="margin-left: 10px;width: 98px;height: 33px;margin-bottom:9px" src="../../../../assets/imgs/3X.png" width="48" height="40" alt="credit-card"></span>
                <input type="checkbox" (change)="severalPayment($event)" [checked]="!isNormalPayment" class="customYumanCheckBox" > <span class="customYumanCheckboxLabel">{{event.number_of_maturity}}x sans frais</span>
              </div>
        </div>-->
    <!--    <div class="table-row flexible width-100">
          <div class="column flexible index text-center">02</div>
          <div class="flexible width-100">
            <div class="column flexible title text-left"><span>VIP Ticket</span> <span class="opacity-50">(Sun, 22 Jun 2014 at 08:45 AM)</span></div>
            <div class="column flexible has-price"><span class="price cur-euro"></span></div>
            <div class="column flexible has-input flexible"><input type="number" name="" disabled value="2" class="text-left"></div>
            <div class="column flexible has-price"><span class="price cur-euro">40</span></div>
          </div>
        </div>
        <ul class="holders-list">
          <li>Prénoms, <span>Nom</span></li>
          <li>Prénoms, <span>Nom</span></li>
        </ul>-->
        <!--<div class="app-booking-item column flexible title text-right text-uppercase width-100">
          <span class="font-size-20">sous total</span>
          <span class="price font-size-20 " *ngIf="isNormalPayment">{{calculTotal(pricings) | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
          <span class="price font-size-20" *ngIf="!isNormalPayment">{{get_amount_by_maturity(calculTotal(pricings)) | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
        </div>

        <div class="app-booking-item column flexible title text-right text-uppercase width-100" style="margin-top: -28px;" *ngIf="calculateOptionTotal()>0">
          <span class="font-size-20">total des options</span>
          <span class="price font-size-20 " *ngIf="isNormalPayment">{{calculateOptionTotal() | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
          <span class="price font-size-20" *ngIf="!isNormalPayment">{{get_amount_by_maturity(calculateOptionTotal()) | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
        </div>

        <div *ngFor="let code of codePromosActivated" class="app-booking-item column flexible title text-right text-uppercase width-100">
          <span>Réduction :{{' '+code.name}}</span>
          <span class="price ">{{codeReduct(code)}}</span>
        </div>

        <div *ngIf="calculTotal(pricings)>0" class="app-booking-item app-booking-item&#45;&#45;price column flexible title text-right text-uppercase width-100" style="margin-top: -25px;font-size: 12px;color: grey">
          <span *ngIf="!event.has_open_ticketing">{{'front_booking_payment.booking_fee'| translate}}</span>
          <span *ngIf="event.has_open_ticketing">{{'front_booking_payment.service_fee'| translate}}</span>
          <span class="price ">{{frais | number : '1.2-2'}} {{functionUtils.getPricingDeviseSymbole(devise)}}</span>
        </div>

        <div class="app-booking-item column flexible title text-right text-uppercase width-100" style="margin-top: -8px;font-size: 20px;">
          <span>{{'front_booking_payment.final_total'| translate}}</span>
          <span class="price  text-green">{{displayTotal(order.total_price)}}</span>
        </div>-->

      </div>
    </div>

    <header class="flexible m-top-50">
      <h5 class="inline-block text-uppercase">
        <span *ngIf="order.total_price > 0"> 02. paiement</span>
        <span *ngIf="order.total_price === 0"> 02. Valider</span>
      </h5>
      <a  title="Montrer/Cacher les détails" class="inline-block text-uppercase">
        <i class="fa fa-edit"></i>
      </a>
    </header>

    <div class="form-group row col-md-10 font-size-18 margin-bottom-20" style="margin-top: 20px" *ngIf="calculTotal(pricings) > event.paymentStartFrom && eventGotMultiPayment() ">

      <div class="col-md-5 checkbox">
        <label><input type="checkbox" class="customYumanCheckBox" [checked]="isNormalPayment"  (change)="normalPayment($event)" value="">
          <img style="margin-left: 10px" src="../../../../assets/imgs/credit-card.png" width="48" height="40" alt="credit-card">
          <span class="customYumanCheckboxLabel" style="margin-left: 10px">Carte bancaire</span>
        </label>
      </div>

      <div class="col-md-5 checkbox">
        <span *ngIf="event.number_of_maturity == 4"> <img style="margin-left: 10px;width: 98px;height: 33px;margin-bottom:9px" src="../../../../assets/imgs/4X.png" width="48" height="40" alt="credit-card"></span>
        <span *ngIf="event.number_of_maturity == 3"> <img style="margin-left: 10px;width: 98px;height: 33px;margin-bottom:9px" src="../../../../assets/imgs/3X.png" width="48" height="40" alt="credit-card"></span>
        <input type="checkbox" (change)="severalPayment($event)" [checked]="!isNormalPayment" class="customYumanCheckBox" > <span class="customYumanCheckboxLabel">{{event.number_of_maturity}}x sans frais</span>
      </div>
    </div>

     <div *ngIf="!isNormalPayment">
       <div>
         <div class="row-bg-color row-padding">
           <span class="text-uppercase bold" style="font-weight: bold">1er échéance: </span>
         </div>
         <div class="row-pading-content">
           <span class="text-uppercase bold" style="font-weight: bold">1er échéance: </span><span class="bg-color ft-size-20">{{' '+displayTotal(order.total_price)}}</span>
         </div>
       </div>
         <div>
           <div class="row-bg-color row-padding">
             <span class="text-uppercase bold">prochaines échéances</span>
           </div>
           <div *ngFor="let deadline of next_deadlines" class="ft-size-17" style="margin-left: 10px">
           <span  class="inline-block">
            {{'- Le '+deadline.date+' : '}}
           </span>
             <span class="bg-color inline-block">
             {{deadline.amount.toFixed(2)+functionUtils.getPricingDeviseSymbole(devise)}}
           </span>
           </div>

           <div class="row-padding mt-10">
             <input type="checkbox" (change)="I_undertake_to_honor_change()" [checked]="I_undertake_to_honor" class="customYumanCheckBox" > <span class="customYumanCheckboxLabel font-size-18">Je m'engage à honorer les futurs paiements dont je recevrai les demandes par email</span>
           </div>
         </div>
       <div class="row-bg-color row-padding">
         <span>Paiement </span>
       </div>
     </div>
   </div>

<div class="container col-md-7" style="margin-bottom: 50px;margin-top: 50px">
  <app-paiement-module (messageEvent)="receivePaymentMessage($event)"></app-paiement-module>
</div>


<!--<div class="details-cmd" id="credit-card">
  <div class="container" style="margin-bottom: 35px;">
    <a (click)="retour()" title="Valider mon paiement" class="btn inline-block btn-green width-100-475">{{'front_booking_payment.return'| translate}}</a>
    <a (click)="valider()" title="Valider mon paiement" class="btn inline-block btn-green width-100-475">{{'front_booking_payment.validate'| translate}}</a>
  </div>
</div>-->
</div>
